import React from "react";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import { IconButton } from "@material-ui/core";
import gql from "graphql-tag";
import { useMutation } from "@apollo/react-hooks";

export const BRISI_RASU = gql`
  mutation brisiRasu($_id: ID) {
    brisiRasu(_id: $_id) {
      _id
    }
  }
`;

type PropTypes = {
  id: string;
};

export default function BrisiRasu(props: PropTypes) {
  const [brisiRasu] = useMutation(BRISI_RASU);

  return (
    <IconButton
      onClick={() => {
        brisiRasu({
          variables: { _id: props.id },
          refetchQueries: ["ucitajRase"],
        });
      }}
    >
      <DeleteForeverIcon />
    </IconButton>
  );
}
